export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" stroke=\"#3F4450\" stroke-width=\".95\" d=\"M9.339 8.181l-5.462 8.566c-.154.244-.532.102-.488-.183l.944-6.23H.947a.334.334 0 01-.281-.517l5.517-8.56c.157-.243.534-.102.488.183L5.667 7.667h3.389c.265 0 .425.292.283.514z\"/><path d=\"M-3 1h16v16H-3z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "10",
    "height": "18",
    "viewBox": "0 0 10 18"
  }
};